export const FILTER_OPTIONS = {
  ORIGIN: 'origin',
  CITY: 'tradesman_city',
  CATEGORY: 'category',
  WORK_CITY: 'tradesman_work_city',
}

export const FILTERS = [
  {
    name: FILTER_OPTIONS.ORIGIN,
    label: 'Origem',
    type: 'select',
    options: [
      { value: 'agency_tradesman', label: 'Meus Prestadores' },
      { value: 'refera_tradesman', label: 'Refera Prestadores' },
      { value: 'all_tradesman', label: 'Todos Prestadores' },
    ],
  },
  {
    name: FILTER_OPTIONS.CATEGORY,
    label: 'Categoria',
    type: 'select',
    options: [],
  },
  {
    name: FILTER_OPTIONS.WORK_CITY,
    label: 'Cidade de Atuação do prestador',
    type: 'select',
    options: [],
  },
  {
    name: FILTER_OPTIONS.CITY,
    label: 'Cidade do prestador',
    type: 'select',
    options: [],
  },
]
